module.exports = __webpack_public_path__ + "img/Zimmer_Deko.d4266e0b.jpg";